import { Action } from "@ngrx/store";
import { ITermsAndConditions } from "../../models/termsAndConditions";

export enum ETermsAndConditionsActions {
  UpdateTermsAndConditionsCheckboxState = "[UPDATE] Terms And Conditions Checkbox State",
}

export class UpdateTermsAndConditionsCheckboxState implements Action {
  public readonly type =
    ETermsAndConditionsActions.UpdateTermsAndConditionsCheckboxState;
  constructor(public payload: boolean) {}
}

export type TermsAndConditionsActions = UpdateTermsAndConditionsCheckboxState;
